import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'ui/organisms'
import { ConfigService, ContactService, IntlService } from 'services'
import FormChallenge from '../misc/FormChallenge'

export default function ContactForm({ dataPrivacyUrl, successUrl, errorUrl }) {
  const [category, setCategory] = useState(undefined)
  const [product, setProduct] = useState(undefined)
  const [topic, setTopic] = useState(undefined)
  const [info, setInfo] = useState(undefined)
  const [showProductSelect, setShowProductSelect] = useState(false)
  const [showTopicSelect, setShowTopicSelect] = useState(false)
  const [fieldErrors, setFieldErrors] = useState([])

  const categoryOptions = ConfigService.get('contact.categories').map(value => ({
    value,
    label: IntlService.get(`contactform.category.${value}`)
  }))
  const productOptions = ConfigService.get('contact.products').map(value => ({
    value,
    label: IntlService.get(`contactform.product.${value}`)
  }))
  const topicOptions = ConfigService.get('contact.topics').map(value => ({
    value,
    label: IntlService.get(`contactform.topic.${value}`)
  }))

  useEffect(() => {
    setShowProductSelect(category === 'consult')
  }, [category])

  useEffect(() => {
    setShowTopicSelect(showProductSelect && product === 'adsl')
  }, [showProductSelect, product])

  useEffect(() => {
    if (!showProductSelect) setProduct(undefined)
    if (!showTopicSelect) setTopic(undefined)
  }, [showProductSelect, showTopicSelect])

  useEffect(() => {
    const infoLocaKey = `contactform.info.${[category, product, topic].filter(Boolean).join('.')}`
    setInfo(IntlService.get(infoLocaKey))
  }, [category, product, topic])

  const onSubmit = (e, { data }) => {
    ContactService.send(data)
      .then(() => {
        window.location.href = successUrl || window.location.href
      })
      .catch(e => {
        if (e && e.fieldErrors) {
          setFieldErrors(
            e.fieldErrors.map(({ fieldName, errorMessage, errorCode }) => {
              if (errorCode) {
                errorMessage = IntlService.get(`contactform.errors.${errorCode}`)
              }

              return { fieldName, errorMessage }
            })
          )
        } else {
          console.error(e)
          window.location.href = errorUrl || window.location.href
        }
      })

    return false
  }

  return (
    <Form fieldErrors={fieldErrors} method="POST" onSubmit={onSubmit} noAction>
      <Form.Row className="mb-1">
        <Form.Col className="d-flex">
          <Form.Select
            className="col-12 d-block p-0"
            name="category"
            placeholder="Bitte wählen Sie eine Kategorie*"
            onChange={({ value }) => setCategory(value)}
            options={categoryOptions}
            required
          />
        </Form.Col>
      </Form.Row>
      {category === 'dsa' && (
        <>
          <Form.Row className="mb-1">
            <Form.Col>
              <p>
                <strong>
                  Mit Hilfe dieses Formulars können rechtswidrige Inhalte an die 1&1 gemeldet werden. Es können hierbei
                  ausschließlich Inhalte in Diensten gemeldet werden, deren Hostingdiensteanbieter die 1&1 Telecom GmbH
                  ist.
                </strong>
              </p>
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Col>
              <label className="form-label">
                Bitte erläutern Sie, weshalb es sich Ihrer Meinung nach um einen rechtswidrigen Inhalt handelt.
              </label>
              <Form.TextArea name="comments" type="text" placeholder="Erläuterung*" required />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Col>
              <label className="form-label">
                Bitte geben Sie den genauen elektronischen Speicherort des rechtswidrigen Inhalts an (z.B. eine präzise
                URL-Adresse) oder machen Sie Angaben zur Ermittlung der rechtswidrigen Inhalte.
              </label>
              <Form.Input name="location" type="text" placeholder="Speicherort*" required />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Col>
              <label className="form-label">Name der meldenden Person / Einrichtung (freiwillig)</label>
              <Form.Input name="name" type="text" placeholder="Name" />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Col>
              <label className="form-label">E-Mail-Adresse der meldenden Person / Einrichtung (freiwillig)</label>
              <Form.Input name="email" type="email" placeholder="E-Mail-Adresse" />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Col>
              <label className="toggle-label toggle-label--checked toggle-label--checkbox">
                <span className="toggle-label__text">
                  Ich erkläre hiermit, dass ich in gutem Glauben davon überzeugt bin, dass die in der Meldung
                  enthaltenen Angaben und Anführungen richtig und vollständig sind.
                </span>

                <input className="toggle-label__radio" type="checkbox" name="checkbox" value="value" required />

                <span className="toggle-label__checkmark">
                  <svg viewBox="0 0 100 100" className="icon toggle-label__checkmark--checked">
                    <use xlinkHref="#check"></use>
                  </svg>
                </span>
              </label>
            </Form.Col>
          </Form.Row>
        </>
      )}
      {showProductSelect && (
        <Form.Row className="mb-1">
          <Form.Col className="d-flex">
            <Form.Select
              className="col-12 d-block p-0"
              name="product"
              placeholder="Bitte wählen Sie ein Produkt*"
              onChange={({ value }) => setProduct(value)}
              options={productOptions}
              required
            />
          </Form.Col>
        </Form.Row>
      )}
      {showTopicSelect && (
        <Form.Row className="mb-1">
          <Form.Col className="d-flex">
            <Form.Select
              className="col-12 d-block p-0"
              name="topic"
              placeholder="Bitte wählen Sie ein Thema"
              onChange={({ value }) => setTopic(value)}
              options={topicOptions}
            />
          </Form.Col>
        </Form.Row>
      )}
      {info || category === 'dsa' ? (
        <div dangerouslySetInnerHTML={{ __html: info }}></div>
      ) : (
        <>
          <Form.Row className="mb-1">
            <Form.Col>
              <Form.Input name="email" type="email" placeholder="E-Mail-Adresse*" required />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-1">
            <Form.Col className="col-md-6 mb-1 mb-md-0">
              <Form.Input name="firstName" placeholder="Vorname*" required />
            </Form.Col>
            <Form.Col className="col-md-6">
              <Form.Input name="lastName" placeholder="Name*" required />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-1">
            <Form.Col className="col-md-10 mb-1 mb-md-0">
              <Form.Input name="street" placeholder="Straße" />
            </Form.Col>
            <Form.Col className="col-md-2">
              <Form.Input name="streetNumber" placeholder="Nr." />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-1">
            <Form.Col className="col-md-2 mb-1 mb-md-0">
              <Form.Input name="zipCode" placeholder="PLZ" />
            </Form.Col>
            <Form.Col className="col-md-10">
              <Form.Input name="city" placeholder="Ort" />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-1">
            <Form.Col>
              <Form.PhoneInput name="phoneNumber" placeholder="Telefonnummer für eventuelle Rückfragen" />
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-1">
            <Form.Col>
              <Form.TextArea name="message" placeholder="Ihre Frage an uns*" required />
            </Form.Col>
          </Form.Row>
        </>
      )}
      {info ? (
        ''
      ) : (
        <>
          <FormChallenge />
          <Form.Row className="mb-1">
            <Form.Col>
              <small>* Pflichtfelder müssen ausgefüllt werden.</small>
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Col>
              <a href={dataPrivacyUrl} target="_blank" rel="noopener noreferrer" className="textlink font-size--small">
                <span className="link__text">
                  <span>Hinweise zum Datenschutz</span>
                </span>
              </a>
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-1">
            <Form.Col>
              <Form.Button text="Abschicken" secondary />
            </Form.Col>
          </Form.Row>
        </>
      )}
    </Form>
  )
}

ContactForm.propTypes = {
  dataPrivacyUrl: PropTypes.string,
  successUrl: PropTypes.string,
  errorUrl: PropTypes.string
}

ContactForm.defaultProps = {
  dataPrivacyUrl: '#Privacy',
  successUrl: '#Versendet',
  errorUrl: '#Error'
}
